let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("fe4be"), load("ffEVr"), load("8059b"), load("eA5B3")]).then(() => parcelRequire('gcJKc'));